import { PrimitiveAtom, atom, useAtom, useSetAtom } from "jotai";
import { OrderV2 } from "../v2/queries/interfacesV2";

export const orderAtom = atom<OrderV2 | undefined>(undefined) as PrimitiveAtom<
  OrderV2 | undefined
>;

const useLiveOrder = () => {
  return useAtom(orderAtom);
};

export const useSetLiveOrder = () => useSetAtom(orderAtom);

export default useLiveOrder;
